import { useState } from 'react';

import { useIsomorphicLayoutEffect } from '@lib/hooks'

import { useTradeStore } from './useTradeStore';

/** 用户的币币账户列表 */
export const useAssetAccountMap0 = () => {
  const tradeStore = useTradeStore();
  const [assetAccount, setAssetAccount] = useState<any[]>([])
  const getAssetAccount = async () => {
    const [, assetAccount] = await tradeStore.fetchAccountAssets('0', false);
    setAssetAccount(assetAccount || []);
  }

  useIsomorphicLayoutEffect(() => {
    const assetAccountMap = tradeStore.assetAccountMap;
    if (assetAccountMap?.[0]?.length) {
      setAssetAccount(assetAccountMap[0])
      return
    }
    getAssetAccount();
  }, [tradeStore.assetAccountMap])
  return assetAccount;
}
